
import { defineComponent, getCurrentInstance, ref } from "vue";
import axios, { AxiosResponse } from "axios";

import apis, { CreateModel } from "@/apis";
import { AlertQueue } from "@/utils/alertQueue";
import { Modal } from "bootstrap";

import UsageInfo from "@/components/UsageInfo.vue";
import { useRouter } from "vue-router";


export default defineComponent({
  setup() {
    var title = ref("");
    var showOrHide = ref(false);
    var hasBtn = ref(true);
    var jumpUrl = ref("javascript:void(0);");
    const vm = getCurrentInstance();
    const router = useRouter(); 
    const createModel = ref({
      content: "",
    } as CreateModel);
    type myExtmodel ={ 
          region:string|undefined,
    };
    const Extmodel  =ref({region:undefined,}as myExtmodel)

    const showTipModal = (pTitle:string,pHasBtn:boolean,pJumpUrl:string) =>{
      title.value = pTitle;
      hasBtn.value = pHasBtn;
      jumpUrl.value = pJumpUrl;
      showOrHide.value = true;
    }

    const fileModel = ref(undefined as File | undefined);
    const fileArr = ref([] as File[]);

    const hb = ref(null as string | null);

    const showModal = () => {
      const el = vm?.refs["modal"] as Element;
      const bsEl = Modal.getOrCreateInstance(el);
      bsEl?.show();
    }

    const onFileChanged = (ev: Event) => {
      const target = ev.target as HTMLInputElement;
      if (target && target.files) {
        fileModel.value = target.files[0];
        fileArr.value.push(target.files[0]);
      }
    }
    const deleteFile = (index:number) => {
      //console.log(index);
      fileArr.value.splice(index,1);
      //console.log(fileArr.value);
    }
    const getCookie =(cname:string) => {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name)==0) { return c.substring(name.length,c.length); }
      }
      return "";
    }

    const getAppUserInfo = () =>{
      var token = getCookie("wxqz-app-token-3");
      const html = "";
      var ret=0;
      if(!(token)){
        ret=1;
        return ret;
      }
      axios.post(
        'https://apiv2.qz123.com/api/Register/GetUserIdentity'
        ,
        {
          token:token
        }
      )
      .then((resp)=>  {
          var data:any = resp.data;
          if(data != null && data != undefined && data != ""){
                if(data.app=="1"){
                //在app中
                    if(!data.id){
                    //未登录
                    ret=2;
                    }
                }else{
                    ret=3;
                }
          }
            else
            {
              ret=4;
            }

        }).catch( (error) => {
          alert(error);
      });
      return ret;
    };
    
    const submitContent = async (bypassEmpty?: boolean) => {
      var ret=0;
      await axios.get('https://www.qz123.com/papi/switches/rwtoken').then((response) => {
        var data:any = response.data;
        if(data != null && data != undefined && data != ""){
          if(data.result){
            ret=getAppUserInfo();
          }
        }
      })
      if(ret==1)
      {
        showTipModal("温馨提示：请到无线衢州app中提交",true,"https://www.qz123.com/app/down.html");
        return;
      }
      else if(ret==2)
      {
        showTipModal("温馨提示：您当前未登录，无法提交，请先到我的页面登录！",false,"javascript:void(0);");
        return;
      }
      else if(ret==3 || ret==4)
      {
        showTipModal("温馨提示：请到无线衢州app中提交",true,"https://www.qz123.com/app/down.html");
        return;
      }

      if (!bypassEmpty && !fileModel.value && fileArr.value.length > 0) {
        showModal();
        return;
      }

      try {
        if (hb.value === null)
          hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];

        // eslint-disable-next-line
        let d: AxiosResponse<any, any>;
        if (!hb.value) {
          AlertQueue.danger("app configuration failed");
          return;
        }
        createModel.value.jext= JSON.stringify(Extmodel.value);

        d = await apis.apiPostCreate(createModel.value, hb.value);
        if (!d || d.data.status < 200 || d.data.status >= 300) {
          AlertQueue.warn("提交失败, 请重试");
          return;
        }

        //AlertQueue.warn("附件上传中，请稍候片刻……");
        // if (fileModel.value){
        //   d = await apis.apiPostUpload(fileModel.value, hb.value);
        // }
        //showTipModal("正在保存您上传的图片[共"+fileArr.value.length+"张，剩余"+fileArr.value.length+"张]，请稍候...",false,"javascript:void(0);");
        //for(var i = 0;i<fileArr.value.length;i++){
        //  d = await apis.apiPostUpload(fileArr.value[i], hb.value);
        //  if(i<fileArr.value.length-1){
        //    showTipModal("正在保存您上传的图片[共"+fileArr.value.length+"张，剩余"+(fileArr.value.length-(i+1))+"张]，请稍候...",false,"javascript:void(0);");
        //  }
        //}
        AlertQueue.info("提交成功，重定向至精彩留言……");
        apis.resetCreateModel(createModel.value);
        router.push({ name: 'artworks', params: { channel: 0, page: `1` } });
      } catch (e) {
        AlertQueue.danger(e);
      }
    };
    

    return {
      createModel,
      submitContent,
      onFileChanged,
      fileModel,
      fileArr,
      showOrHide,
      title,
      hasBtn,
      jumpUrl,
      deleteFile,
      getAppUserInfo,
      Extmodel
    };
  },
  components: {
    UsageInfo,
  }
});
